import {
  FORM_COMPONENT_ADVANCED_INPUT_TYPE,
  FORM_COMPONENT_BASIC_INPUT_TYPE,
  FORM_COMPONENT_FORM_BUILDER_INPUT_TYPE,
} from '../../schemas/formComponentInputTypeSchema';

const mobilePreviewSchema: Record<
  FORM_COMPONENT_BASIC_INPUT_TYPE | FORM_COMPONENT_FORM_BUILDER_INPUT_TYPE | FORM_COMPONENT_ADVANCED_INPUT_TYPE,
  Record<'answer', Record<string, string> | null> | undefined
> = {
  [FORM_COMPONENT_BASIC_INPUT_TYPE.text]: {
    answer: { en: 'Answer', fr: 'Réponse' },
  },
  [FORM_COMPONENT_BASIC_INPUT_TYPE.email]: {
    answer: { en: 'email@example.com', fr: 'email@example.com' },
  },
  [FORM_COMPONENT_BASIC_INPUT_TYPE.phone]: {
    answer: { en: '+1 (234) 567-8901', fr: '+1 (234) 567-8901' },
  },
  [FORM_COMPONENT_BASIC_INPUT_TYPE.date]: {
    answer: { en: 'Dec 30, 2025', fr: '30 déc. 2025' },
  },
  [FORM_COMPONENT_BASIC_INPUT_TYPE.time]: {
    answer: { en: '05:45 AM', fr: '5h45' },
  },
  [FORM_COMPONENT_BASIC_INPUT_TYPE.link]: {
    answer: null,
  },
  [FORM_COMPONENT_BASIC_INPUT_TYPE.number]: {
    answer: { en: '123456', fr: '123456' },
  },
  [FORM_COMPONENT_BASIC_INPUT_TYPE.address]: {
    answer: { en: '123 Main St, Anytown, USA', fr: '123 Main St, Anytown, USA' },
  },
  [FORM_COMPONENT_BASIC_INPUT_TYPE.checkbox]: {
    answer: null,
  },
  [FORM_COMPONENT_BASIC_INPUT_TYPE.gender]: {
    answer: null,
  },
  [FORM_COMPONENT_BASIC_INPUT_TYPE.radio]: {
    answer: null,
  },
  [FORM_COMPONENT_BASIC_INPUT_TYPE.image]: {
    answer: null,
  },
  [FORM_COMPONENT_BASIC_INPUT_TYPE.file]: {
    answer: null,
  },
  [FORM_COMPONENT_BASIC_INPUT_TYPE.yesNo]: {
    answer: { en: 'Yes', fr: 'Oui' },
  },
  [FORM_COMPONENT_BASIC_INPUT_TYPE.documentReview]: {
    answer: null,
  },
  [FORM_COMPONENT_BASIC_INPUT_TYPE.singleCheckbox]: {
    answer: null,
  },
  [FORM_COMPONENT_BASIC_INPUT_TYPE.button]: {
    answer: null,
  },
  [FORM_COMPONENT_BASIC_INPUT_TYPE.bankAccountNumber]: {
    answer: { en: '1234567890', fr: '1234567890' },
  },
  [FORM_COMPONENT_BASIC_INPUT_TYPE.routingNumber]: {
    answer: { en: '1234567890', fr: '1234567890' },
  },
  [FORM_COMPONENT_BASIC_INPUT_TYPE.branchTransitNumber]: {
    answer: { en: '1234567890', fr: '1234567890' },
  },
  [FORM_COMPONENT_BASIC_INPUT_TYPE.financialInstitutionNumber]: {
    answer: { en: '1234567890', fr: '1234567890' },
  },
  [FORM_COMPONENT_BASIC_INPUT_TYPE.correspondenceLanguage]: {
    answer: null,
  },
  [FORM_COMPONENT_BASIC_INPUT_TYPE.sin]: {
    answer: { en: '223-08-4452', fr: '223-08-4452' },
  },
  [FORM_COMPONENT_BASIC_INPUT_TYPE.ssn]: {
    answer: { en: '223-08-4452', fr: '223-08-4452' },
  },
  [FORM_COMPONENT_BASIC_INPUT_TYPE.signature]: undefined,
  [FORM_COMPONENT_FORM_BUILDER_INPUT_TYPE.section]: undefined,
  [FORM_COMPONENT_ADVANCED_INPUT_TYPE.documentPreview]: undefined,
  [FORM_COMPONENT_ADVANCED_INPUT_TYPE.canadianBank]: undefined,
  [FORM_COMPONENT_ADVANCED_INPUT_TYPE.americanBank]: undefined,
  [FORM_COMPONENT_ADVANCED_INPUT_TYPE.emergencyContact]: undefined,
  [FORM_COMPONENT_ADVANCED_INPUT_TYPE.miscellaneous]: undefined,
  [FORM_COMPONENT_ADVANCED_INPUT_TYPE.earliestStartDate]: undefined,
  [FORM_COMPONENT_ADVANCED_INPUT_TYPE.addressValidator]: undefined,
  [FORM_COMPONENT_BASIC_INPUT_TYPE.info]: undefined,
  [FORM_COMPONENT_BASIC_INPUT_TYPE.checkboxDisable]: undefined,
  [FORM_COMPONENT_ADVANCED_INPUT_TYPE.sinAdvanced]: undefined,
  [FORM_COMPONENT_ADVANCED_INPUT_TYPE.ssnAdvanced]: undefined,
  [FORM_COMPONENT_ADVANCED_INPUT_TYPE.signatureAdvanced]: undefined,
  [FORM_COMPONENT_ADVANCED_INPUT_TYPE.fullName]: undefined,
};

export default mobilePreviewSchema;
